import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import "./PrivacyPolicy.css"
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
const PrivacyPolicy = () => {
    return (
        <>
            <div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>PrivacyPolicy</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>PrivacyPolicy</h6></div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="continer">
                <div class="static_pages">
                    <br /><div class="span"><b>Overview:</b></div><br />
                    <p>RoyalHood Proprietary is committed to protecting your privacy. This policy explains how we collect, use, and protect your personal data in accordance with the General Data Protection Regulation (GDPR).</p>
                    <br /><div class="span"><b>Information We Collect</b></div><br />
                    <p>Personal Information: Name, email address, phone number, and billing details.</p>
                    <p>Usage Data: IP address, browser type, pages visited, and duration of visits.</p>
                    <p>Cookies: To enhance user experience and analyze website traffic. You can manage cookie preferences via your browser settings.</p>
                    <br /><div class="span"><b>How We Use Your Information:</b></div><br />
                    <p>To provide and maintain our services.

To process payments and rentals.

To communicate important updates and promotional offers (with your consent).

To improve our website and tailor user experiences.</p><br/>
                    <ul>
                    <div class="span"><b>Your Rights:</b></div><br/>
                        <li>Access: You can request a copy of your personal data.</li>
                        <li>Rectification: You can correct any inaccuracies in your data.</li>
                        <li>Erasure: You have the right to request deletion of your data, subject to legal obligations.</li>
                        <li>Restriction: You may limit the processing of your data.</li>
                        <li>Objection: You can object to data processing for marketing purposes.</li>
                        <li>Data Portability: You can request a transfer of your data to another service provider.</li>
                    </ul><br/>
                    <p>Sharing Your Data We may share your data with third-party service providers (e.g., payment processors) strictly for the purpose of providing services. We do not sell or trade your personal data.</p><br/>
                    <p>Data Security Your data is stored securely and protected using encryption technologies. Access is limited to authorized personnel only.</p><br/>
                    <p>Data Retention We retain your data only as long as necessary to fulfill the purposes outlined in this policy or as required by law.</p><br/>
                    <p>Contact Information If you have any questions, concerns, or requests regarding this privacy policy or your rights, please contact us at: +91-9620072626</p><br/>
                </div>
            </div>
            <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        {/* <div class="toolbar-item">
            <a style={{color:"black"}} href="#" >
                <div class="toolbar-icon">
                <MdOutlineAccountCircle />
                </div>
                <div class="toolbar-label">Account</div>
            </a>
        </div> */}

        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
        </>
    );
};
export default PrivacyPolicy;